import { createFileRoute } from '@tanstack/react-router'
import { EditPetPage } from '_/features/pets/ui/pages/edit-pet-page'

const EditPetRoute = () => {
	const { petId } = Route.useParams()
	return <EditPetPage petId={petId} />
}

export const Route = createFileRoute('/_authenticated/pets/$petId/edit')({
	staticData: { title: 'pets_edit_title' },
	component: EditPetRoute,
})
